webpackJsonp([235903635285776],{

/***/ 1053:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0027_lobber.jpg","type":"Unit","subtype":"Brigand","cost":1,"ATK":2,"HP":2,"rules_text_1":"Haste (Can attack and play ⤵ abilities the turn he arrives.)","rules_text_2":"⤵ → Deal 1 damage to a building.","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Lobber","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Red","spec":"Fire","bottom":"Tech I","rulings":[],"keywords":["Haste"],"slug":"lobber"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"lobber","keywords":["Haste"],"imageRegex":"/lobber.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-lobber-8d6ff7532200c2b7e782.js